import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=5adfc330"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=5adfc330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports